/* eslint-disable check-i18n-id-prefix/i18n-id-prefix-with-package-name-defineMessages */
// The message IDs below intentionally use the import-from-sources package prefix so that
import { defineMessages } from 'react-intl';

// These message IDs are intentionally kept in sync with the ones in
// @confluence/import-from-sources so that locale-aware folder-name comparisons
// remain accurate. See useIsImportedPage.ts for usage.
const i18n = defineMessages({
	msWordFolderName: {
		id: 'import-from-sources.sources-list.msWordFolderName',
		defaultMessage: 'Word Documents',
		description:
			'Default name for the folder in the Confluence page tree where documents imported from Microsoft Word are placed. Shown as a page tree node label after a Word document import completes.',
	},
	gdocFolderName: {
		id: 'import-from-sources.sources-list.gdocFolderName',
		defaultMessage: 'Google Drive',
		description:
			'Default name for the folder in the Confluence page tree where documents imported from Google Docs are placed. Shown as a page tree node label after a Google Docs import completes.',
	},
	oneDriveFolderName: {
		id: 'import-from-sources.sources-list.oneDriveFolderName',
		defaultMessage: 'OneDrive',
		description:
			'Default name for the folder in the Confluence page tree where documents imported from Microsoft OneDrive are placed. Shown as a page tree node label after an OneDrive import completes.',
	},
});

export const IMPORT_FOLDER_NAMES: {
	readonly wordDoc: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	readonly gDoc: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	readonly office365Doc: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = {
	wordDoc: i18n.msWordFolderName,
	gDoc: i18n.gdocFolderName,
	office365Doc: i18n.oneDriveFolderName,
} as const;
